import { createReducer } from "@reduxjs/toolkit";
import { handleAuthError, resetAuthError } from "./handle-auth-error";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { loginUser } from "@user-management-context/write/application/use-cases/user-login/login-user";

const initialState: { error: Nullable<string> } = { error: null };

export const handleAuthErrorReducer = createReducer<{ error: Nullable<string> }>(initialState, builder => {
  builder.addCase(handleAuthError, (state, action) => {
    // The error NAME, not the message: useAuthErrorRedirect matches on names, so
    // anything else here silently disables the toast and the session cleanup.
    return {
      ...state,
      error: action.payload.name,
    };
  });
  builder.addCase(resetAuthError, () => {
    return initialState;
  });
  builder.addCase(loginUser.fulfilled, () => {
    return initialState;
  });
});
